/* eslint-disable indent */
/* eslint-disable no-shadow */
import './style.scss';

import { getAllStatistics } from 'apis/projectProposalsDefenses.api';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { mapError } from 'utils/func';
import { Card } from 'primereact/card';

function ProjectProposalDefenseStatistics() {
  // #region Data
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, isError, error } = useQuery(['projectProposalsDefense'], getAllStatistics);
  // #endregion

  return (
    <div className="grid">
      <div className="col-12">
        <div className="card">
          {isError && <h3 className="text-red-600">{mapError(t, error)}</h3>}
          {/* Statistics Card */}
          <div className="grid gap-3 mb-2">
            <div className="col-12">
              <Card
                className="bg-blue-700 text-white statistics-card"
                style={{ minHeight: '150px' }}
              >
                <div className="text-center mb-3">
                  <div className="text-lg font-medium">{t('statistics.council')}</div>
                </div>
                <div className="grid">
                  <div
                    className="col-6 text-center cursor-pointer"
                    onClick={
                      () =>
                        navigate('/project-proposal-defense', {
                          state: { reviewStatus: ['notReviewed'] },
                        })
                      // eslint-disable-next-line react/jsx-curly-newline
                    }
                  >
                    <div className="text-2xl font-bold">{data?.data?.totalNotSubmitted || 0}</div>
                    <div className="text-sm">{t('statistics.notReviewed')}</div>
                  </div>
                  <div
                    className="col-6 text-center cursor-pointer"
                    onClick={
                      () =>
                        navigate('/project-proposal-defense', { state: { clearAllFilters: true } })
                      // eslint-disable-next-line react/jsx-curly-newline
                    }
                  >
                    <div className="text-2xl font-bold">{data?.data?.totalCouncils || 0}</div>
                    <div className="text-sm">{t('statistics.totalCouncil')}</div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
          <div className="grid gap-3">
            <div className="col-12">
              <Card
                className="bg-blue-700 text-white statistics-card"
                style={{ minHeight: '150px' }}
              >
                <div className="text-center mb-3">
                  <div className="text-lg font-medium">{t('statistics.totalProject')}</div>
                </div>
                <div className="grid">
                  <div
                    className="col-4 text-center cursor-pointer"
                    onClick={() => navigate('/project-proposal')}
                  >
                    <div className="text-2xl font-bold">{data?.data?.totalProposal || 0}</div>
                    <div className="text-sm">{t('statistics.underReview')}</div>
                  </div>
                  <div
                    className="col-4 text-center cursor-pointer"
                    onClick={() => navigate('/project')}
                  >
                    <div className="text-2xl font-bold">{data?.data?.totalDoing || 0}</div>
                    <div className="text-sm">{t('statistics.onGoing')}</div>
                  </div>
                  <div
                    className="col-4 text-center cursor-pointer"
                    onClick={() => navigate('/project-completed')}
                  >
                    <div className="text-2xl font-bold">{data?.data?.totalCompleted || 0}</div>
                    <div className="text-sm">{t('statistics.completed')}</div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectProposalDefenseStatistics;
